import { render } from "./SupernaturalMapDetailsModal.vue?vue&type=template&id=b7e46920&scoped=true"
import script from "./SupernaturalMapDetailsModal.vue?vue&type=script&lang=js"
export * from "./SupernaturalMapDetailsModal.vue?vue&type=script&lang=js"

import "./SupernaturalMapDetailsModal.vue?vue&type=style&index=0&id=b7e46920&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e46920"]])

export default __exports__